import React, { useEffect, useRef } from "react";
import { Grid, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { style } from "./style";

import { AvailabilityTopHeading } from "../AvailabilitySettings";
import Loader from "../Loader";
import { HospitalCard, TeamCard, TeamDetail } from "./Teams";

import {
  fetchDoctorHospitalListing,
  fetchHospitalTeam,
  ipDashboardDetails,
} from "@/store/slices/doctor/ipDashboard";
import { useAppDispatch, useAppSelector } from "@/store/hooks";

const ClinicalTeams: React.FC = () => {
  const {
    hospitals,
    isHospitalLoading,
    hospitalTeam,
    isHospitalTeamLoading,
    selectedHospitalId,
    viewHospitalTeamDetail,
  } = useAppSelector(ipDashboardDetails);
  const dispatch = useAppDispatch();

  const isFirstRender = useRef(false);

  useEffect(() => {
    dispatch(fetchDoctorHospitalListing());
  }, []);

  useEffect(() => {
    if (selectedHospitalId && !isFirstRender.current) {
      dispatch(fetchHospitalTeam({ hospitalId: selectedHospitalId }));
      isFirstRender.current = true;
    }
  }, [selectedHospitalId]);

  if (isHospitalLoading || isHospitalTeamLoading) {
    return <Loader height="20vh" />;
  }
  return (
    <Grid item>
      <Grid item sx={style.avilabilityTopContainer}>
        <Grid item sx={style.avilabilityTopContainerText}>
          <Typography variant="h4">
            <FormattedMessage
              id="clinical_team"
              defaultMessage="Clinical Team"
            />
          </Typography>
        </Grid>
      </Grid>
      <Grid item sx={style.innerContainer}>
        <Grid item sx={style.hospitalsList}>
          <AvailabilityTopHeading title={`${hospitals?.length} Hospitals`} />
          {hospitals?.map((hospital, index) => (
            <HospitalCard
              {...hospital}
              key={`${hospital.hospital_id}-${index}`}
            />
          ))}
        </Grid>
        <Grid item sx={style.teamList}>
          <AvailabilityTopHeading title={`${hospitalTeam?.length} Members`} />
          {hospitalTeam?.map((team, index) => (
            <TeamCard {...team} key={`${team.userId}-${index}`} />
          ))}
        </Grid>
        {viewHospitalTeamDetail &&
          Object.keys(viewHospitalTeamDetail).length > 0 && (
            <Grid item sx={style.teamDetail}>
              <TeamDetail />
            </Grid>
          )}
      </Grid>
    </Grid>
  );
};

export default ClinicalTeams;
